import * as React from 'react';

import { IDescriptionDispatchProps, IDescriptionStoreProps } from './container';
import styles from './index.css';
import { NavigationLinkTypes } from '../../constants/navigation';
import { trackKpSiteClick, trackShowFullInfoClick } from '../../tracking';
import { ClipboardModify } from '../common/ClipboardModify';
import { Description } from '../common/description';

export type TProps = IDescriptionStoreProps & IDescriptionDispatchProps;

export class About extends React.Component<TProps> {
  public componentDidMount() {
    this.props.setNavigationLink();
  }

  public render() {
    const { description, siteUrl } = this.props;

    return (
      <div className={styles['container']} id={NavigationLinkTypes.About}>
        <ClipboardModify>
          <h2 className={styles['header']}>О коттеджном посёлке</h2>
          <Description
            description={description}
            lineCounter={6}
            showMicrodata={true}
            onShowFullInfoClick={() => trackShowFullInfoClick('KP_info_open')}
          />
          {siteUrl && (
            <div className={styles['site_address_container']}>
              <a
                href={siteUrl}
                className={styles['site_address']}
                onClick={() => trackKpSiteClick(siteUrl)}
                rel="nofollow noopener"
                target="_blank"
              >
                Сайт посёлка
              </a>
            </div>
          )}
        </ClipboardModify>
      </div>
    );
  }
}
